import React, { ChangeEvent } from 'react';

export interface GetOtpProps {
  onChangeOtp?: (ev: ChangeEvent<HTMLInputElement>) => void;
  showLogin?: () => void;
  onSendOtp?: () => void;
  otp?: string;
  errorMessageOtp?: any;
}

export default function GetOtp({
  onChangeOtp,
  showLogin,
  onSendOtp,
  otp,
  errorMessageOtp,
}: GetOtpProps) {
  return (
    <div className="forgot-password-content login-content">
      <div className="title-content text-transform-uppercase">OTP</div>
      <div className="mt-3 under-title">
        <span>
          OTP
        </span>
      </div>
      <div className="email mt-2">
        <input
          type="text"
          className="ant-input ant-input-sm  mb-3 input-login"
          placeholder={'Nhập otp/Enter otp'}
          onChange={onChangeOtp}
        />
        {errorMessageOtp !== null && (
          <div className="login-error mt-3 p-2">{errorMessageOtp}</div>
        )}
      </div>
      <div className="row mt-3">
        <div className="col pointer forgot-password" onClick={showLogin}>
          <i className="tio-arrow_backward mr-2"></i>
          <span>Quay lại/Goback</span>
        </div>
        <div className="col forgot-pass d-flex justify-content-end">
          <button
            className="btn btn-primary btn-sm btn-login"
            onClick={onSendOtp}
            disabled={otp === null}
          >
            {'Lấy lại mật khẩu / Password retrieval'}
          </button>
        </div>
      </div>
    </div>
  );
}
